// @flow
import type { SettingValue } from '~/core/constants/actions';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from '~/components/widgets';
import { Base, DropdownContainer, Label } from './styles';

type Props<T> = {
    currentValue: ?T,
    handleChange: T => {},
    label: $npm$ReactIntl$MessageDescriptor,
    options: Array<SettingValue>
};
const Select = <T>({ currentValue, handleChange, label, options }: Props<T>) => (
    <Base>
        <Label>
            <FormattedMessage {...label} />:
        </Label>
        <DropdownContainer>
            {/* $FlowFixMe */}
            <Dropdown
                currentValue={currentValue !== undefined ? options.findIndex(o => o.value === currentValue) : 0}
                handleChange={index => handleChange(options[index].value)}
                options={options.map(o => o.label)}
            />
        </DropdownContainer>
    </Base>
);
export default Select;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/select/component.js